import { EventAction, EventObjectType } from './types';

export enum EventNames {
  WAITLIST_BUTTON_CLICKED = 'Client Clicks To Join Waitlist',
  WAITLIST_VIEW_LOCATION_STEP = 'Join Waitlist Viewed',
  WAITLIST_VIEW_INFORMATION_STEP = 'Waitlist - Personal Information Viewed',
  WAITLIST_JOIN_SUCCESS = 'Client Successfully Joins Waitlist',
  WAITLIST_JOIN_ERROR = 'Client Failed to Join Waitlist',

  CLIENT_ENTERED_BOOKING_FLOW = 'Client Entered Booking Flow',
  SELECT_BUTTON_CLICKED = 'Client Selected Service',
  SERVICE_OPTIONS_VIEWED = 'Client View Service Options',
  CLIENT_SELECTED_PROFESSIONAL = 'Client Selected Team Member',
  BOOK_BUTTON_CLICKED = 'Client Selected Book Services',
  NEXT_BUTTON_CLICKED_DATE_TIME = 'Client Selected DateTime',
  NEXT_BUTTON_CLICKED_LOCATION = 'Client Selected Location',
  NEXT_BUTTON_CLICKED_CLIENT_INFORMATION = 'Client Entered Personal Details',
  BOOKING_SUCCESS = 'Client Completed Booking',
  RESCHEDULE_BUTTON_CLICKED = 'Client Clicked Reschedule',

  PAYMENT_SETTING_FOR_CLIENT_SUCCESS = 'Payment setting successfully submitted',
  SUBMIT_PAYMENT_INFO_SUCCESS = 'Payment info successfully submitted',
  WAIVER_QUESTION_ACKNOWLEDGED = 'Waiver Question Acknowledged',
  MANAGE_CURRENT_APPOINTMENT = 'Client Views Current Appointment Screen',
  PAY_DEPOSIT = 'Client Views Pay Deposit Screen',
  PAY_DEPOSIT_SUCCESS = 'Client Pays Deposit',
  FORMS_WAIVERS_SUBMITTED = 'Client Submitted Appointment Form',
  FORMS_WAIVERS_VIEWED = 'Client Viewed Appointment Form',

  ORIGIN_SURVEY = 'Origin Survey',
  CLIENT_GOES_BACK_IN_ORIGIN_SURVEY = 'Client Goes Back in Origin Survey',
  CLIENT_CLOSES_ORIGIN_SURVEY = 'Client Closes Origin Survey',
  CLIENT_SUBMITS_ORIGIN_SURVEY = 'Client Submits Origin Survey',
  SESSION_STARTED = 'Session Started',
  CLIENT_NAVIGATED_TO_PAGE = 'Client Navigated to Page',
  AUTOMATED_WAITLIST_ENTRY_VIEWED = 'Client Automated Waitlist Entry',
  AUTOMATED_WAITLIST_BOOK_BUTTON_CLICKED = 'Client Selects Book from Automated Waitlist',

  CLIENT_ENTERED_AUTO_BOOK_FLOW = 'Client Entered Auto Book Flow',
}

export enum EventReferrers {
  RWG = 'reserve_with_google',
  RR = 'rebooking_reminders',
}

export interface SessionStartedEvent {
  action: EventAction;
  objectType: EventObjectType;
  productSection: string;
  productSubSection: string;
}

export interface ButtonClickEvent {
  action: EventAction;
  objectType: EventObjectType;
  objectValue: string;
  productSection: string;
  productSubSection: string;
  referrer?: string;
}

export interface ClientNavigationEvent {
  page_name:
    | 'about'
    | 'team'
    | 'services'
    | 'portfolio'
    | 'contact'
    | 'book'
    | 'shop';
}
